<script>
import Media from '@/components/elements/Media.vue';

export default {
    name: 'VideoEmbed',
    props: {
        videoType: String,
        embedId: String
    },
    data () {
        return {
            isLoaded: false,
            hasClickedPlay: false
        }
    },
    computed: {
        src () {
            let src = '';

            if (this.videoType == 'vimeo') {
                src = `https://player.vimeo.com/video/${this.embedId}?h=b260a3b1b0&autoplay=1&title=0&byline=0&portrait=0&color=e93b36`;
            } else if (this.videoType == 'youtube') {
                src = `https://www.youtube.com/embed/${this.embedId}?autoplay=1&color=white&disablekb=1&modestbranding=1&playsinline=1`;
            }

            return src;
        }
    },
    mounted () {
        this.isLoaded = true;
    },
    components: {
        Media
    }
};
</script>